import { AccountMultiplePlusIcon } from './AccountMultiplePlusIcon';

/**
 * author: Google
 * id 047F8AC1-524D-4077-BCEB-434FE1C50C8B
 * name account-multiple-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-plus.svg
 * tags
 * - Account / User 
 */
export const InviteIcon = AccountMultiplePlusIcon;
export default InviteIcon